import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import { getCotation, duplicateCotation } from 'src/core/redux/action/cotationAction'
import { omit } from 'lodash'
import { withRouter, RouteComponentProps } from 'react-router'
import { ExpensionStepper, ExpensionStep } from 'src/shared/ExpensionStepper'
import CotationInfoStep from 'src/page/Consumer/Product/cotation/step/CotationInfoStep'
import CotationSummaryStep from 'src/page/Consumer/Product/cotation/step/CotationSummaryStep'
import GraphicVisualizationStep from 'src/page/Consumer/Product/cotation/step/GraphicVisualizationStep'
import { IProduct } from 'src/type/product'
import { RootState } from 'src/core/redux/reducer'
import { CtxCotationRequest, withCotationRequest } from 'src/page/Consumer/Product/cotation/CotationRequestProvider'

interface IProps extends WithI18n, 
ReturnType<typeof state2props>,
ReturnType<typeof dispatch2props>,
RouteComponentProps<any>,
CtxCotationRequest {
} 

class RequestTunnel extends React.Component<IProps, {}>{
  render() {
    const{ t } = this.props
    return (
        <ExpensionStepper
            onNext={this.onNext}
            // position={1}
        >
            <ExpensionStep
                index={0}
                label={t.cotation_request.first_step_lbl}
                component={<CotationInfoStep/>}
            />
            <ExpensionStep
                index={1}
                label={t.cotation_request.second_step_lbl}
                component={<GraphicVisualizationStep />}
            />
            <ExpensionStep
                index={2}
                label={t.cotation_request.third_step_lbl}
                component={<CotationSummaryStep />}
            />
        </ExpensionStepper>
    )
  }

    componentWillMount(){
            const { location, updateDataObjProvider, enterprise, product } = this.props
            if(this.isDuplicateRequest()){
                updateDataObjProvider({
                    enterpriseSelected: enterprise,
                    productSelected: {product_type: location.state.productType} as IProduct,
                    formParams: omit(location.state.data, ['cotation']),
                    cotationtDetail: location.state.data.cotation
                })
            } else {
                updateDataObjProvider({
                    enterpriseSelected: enterprise,
                    productSelected: product,
                })
            }
    }

    @autobind
    private isDuplicateRequest(){
        const { location, match } = this.props
        return (location.state && location.state.duplicate) || match.url.includes("cotation-duplicate")
    }

    @autobind
    private onNext(i,d){
        if(d){
            switch(i){
                case 0:
                    return;
                case 1:
                    return;
                case 2:
                    return;
                default:
                    return;
            }
        }
    }
}

const dispatch2props = (dispatch: any) => ({
    get: (productType: string, id: string) => dispatch(getCotation(productType, id)),
    duplicate: (productType: string, cotationId: string) => dispatch(duplicateCotation(productType, cotationId)),
  });
  
  
const state2props = (state: RootState) =>  ({
    enterprise: state.accountInfo.enterpriseSelected,
    product: state.utils.cotationProductSelected
})

export default compose(
    withI18n,
    withRouter,
    withCotationRequest,
    connect(state2props, dispatch2props)
)(RequestTunnel)


// WEBPACK FOOTER //
// ./src/page/Consumer/Product/cotation/step/RequestTunnel.tsx